/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { UsersStrictHttpResponse } from '../../users-strict-http-response';
import { UsersRequestBuilder } from '../../users-request-builder';


export interface AppControllerHandleEvent$Params {
}

export function appControllerHandleEvent(http: HttpClient, rootUrl: string, params?: AppControllerHandleEvent$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<void>> {
  const rb = new UsersRequestBuilder(rootUrl, appControllerHandleEvent.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as UsersStrictHttpResponse<void>;
    })
  );
}

appControllerHandleEvent.PATH = '/o2-users/events';
